/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Labels_LockedInputs */

const en_reading_labels_locked = /** @type {(inputs: Reading_Labels_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document is downloaded, so it reads the labels it was downloaded with. Remove the download to change them.`)
};

const es_reading_labels_locked = /** @type {(inputs: Reading_Labels_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este documento está descargado, así que lee las etiquetas con las que se descargó. Elimina la descarga para cambiarlas.`)
};

/**
* | output |
* | --- |
* | "This document is downloaded, so it reads the labels it was downloaded with. Remove the download to change them." |
*
* @param {Reading_Labels_LockedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_labels_locked = /** @type {((inputs?: Reading_Labels_LockedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Labels_LockedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_labels_locked(inputs)
	return en_reading_labels_locked(inputs)
});